import { Link, useLocation } from "react-router-dom";

const PublicNavbar = () => {
  const location = useLocation();
  return (
    <nav className="bg-white shadow fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-indigo-600">
              Home
            </Link>
            <Link
              to="/games"
              className={`ml-8 text-gray-500 hover:text-gray-700 text-sm font-medium ${
                location.pathname.startsWith("/games") ? "font-bold" : ""
              }`}
            >
              Games
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicNavbar;
